<template>
  <div
    class="login"
  >
    <div class="login__body g-window">
      <img
        class="login__body__logo"
        :src="$i18n.whitelabel.logoImg"
      >
      <img
        v-if="$i18n.whitelabel.logoImgSub"
        :src="$i18n.whitelabel.logoImgSub"
      >
      <h1 class="g-title">
        {{ $i18n.whitelabel.appTitle }}
      </h1>
      <p>
        {{ computedLoginStatus }}
      </p>
    </div>
  </div>
</template>
<script>
import {SocketHandler, LifeCycle, MicroService} from '@/assets/javascript/mixins/Mixins'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import {deleteCookie, getCookie, setDomainCookie} from '@libs/cookie-handling'
import openNGWI from  '@/components/pages/DeviceList.vue'

export default { // TODO: needs refactoring
  name: 'Login',
  mixins: [SocketHandler, LifeCycle, MicroService],
  props: {
    SocketMessage: {
      type: Object,
      default: function() {
        return {}
      }
    },
    store: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  data() {
    return {
      cookie: null,
      status: 'loading'
    }
  },
  computed: {
    computedWhitelabelLogo() {
      return this.$i18n && this.$i18n.whitelabel
      ? `url(${this.$i18n.whitelabel.logoImg})`
      : 'none'
    },
    computedLoginStatus() {
      const list = {
        loading: 'Loading',
        noCookie: 'Redirecting to Login page',
        cookie: 'Logging you in',
        auth: 'Authorized',
        noAuth: 'Unauthorized',
        NCSBadLogin: 'NCS Bad Login',
        ok: 'Starting Application'
      }

      return list[this.status] ? list[this.status] : 'Error'
    }
  },
  watch: {
    SocketMessage(message) {
      const socketData = this.socketMessageRepack(message)

      if(socketData) {
        if(
          socketData.category === 'server' &&
          socketData.command === 'login' &&
          socketData.data.status === 'BAD') {
            this.status = 'NCSBadLogin'
            this.redirect()
        }
        if(
          socketData.category === 'data' &&
          socketData.command === 'get' &&
          socketData.data.type === 'dataset' && 
          socketData.data.record &&
          socketData.data.record[0].login) {
          this.status = 'ok'
          const authToken = this.$route.query.token
          const ctrlid = this.$route.query.ctrlid
          authToken === undefined || ctrlid === undefined ? this.$router.push('devicelist') : this.$router.push('devicelist?token=' + authToken + '&ctrlid=' + ctrlid)
        }
        if(
          socketData.category === 'server' &&
          socketData.command === 'version' &&
          socketData.data.clientNode) {
            this.store.setData('application.versions.nodeClientServer', socketData.data.clientNode.version)
        }
      }
    }
  },
  mounted() {
    //const urlParams = new URLSearchParams(window.location.search)
    //const authToken = urlParams.get('token') ? urlParams.get('token') : undefined
    const authToken = this.$route.query.token
    //const authToken = this.$route.query.token

    if(authToken !== undefined) {
      setDomainCookie(authToken, 'auth')
      }
      
    this.cookie = getCookie('auth')
    this.status = this.cookie ? 'cookie' : 'noCookie'
    this.cookie ? this.login(this.cookie) : this.redirect() 
  },
  methods: {
    redirect() {
      deleteCookie('auth')

      const interval = setInterval(() => {
        clearInterval(interval)
        window.location = this.connection.getConnectionString('sso')
      }, 1000)
    },

    login(authToken) {
      this.sendMicroServiceRequest({
        method: 'GET',
        url: `api/validate-token?token=${authToken}`
      })
      .then((response) => {
        if(response.data.validatetoken) {
          this.status = 'auth'
          this.setMicroServiceAuth(`bearer ${authToken}`)

          this.SocketMessageSend({
            category: 'server',
            command: 'login',
            data: {
              token: authToken
            }
          })
        } else{
          this.status = 'noAuth'
          this.redirect()
        }
      }).catch(this.redirect)
    }
  }
}

</script>
<style lang="scss">
.login {
  height: 100%;
  &__body {
    box-sizing: border-box;
    width: 100%;
    position: fixed;
    top:0%;
    bottom: 0;
    padding-bottom: 20px;

    >*:not(img) {
      padding: 10px 40px 10px;
    }

    &__logo {
      width: 100%;
      background-position: center center;
      background-size: cover;
    }
  }
}

@media screen and (min-width: $bp-mobile) { /* TODO: use global breakpoints*/
  .login__body {
    position: fixed;
    top:50%;
    left: 50%;
    bottom: auto;
    transform: translate3d(-50%, -50%, 0);
    text-align: center;
    overflow: hidden;
    max-width: 375px;
  }
}
</style>
